import { FC, lazy } from 'react';

const UserRegistrationPageDefaultView = lazy(
  () => import('./default-view/UserRegistrationPageDefaultView'),
);

export const UserRegistrationPage: FC = () => <UserRegistrationPageDefaultView />;
